module.exports = __webpack_public_path__ + "img/IMG_20200621_222629.80f3d54e.jpg";